export const SEARCH_QUERY_LENGTH = 2;

// -8640000000000000 is the minimum valid year in Date see (https://stackoverflow.com/a/28425951)
export const DATE_PROPERTIES = {
  MIN_VALUE: -8640000000000000,
  MAX_VALUE: 8640000000000000,
};

export const ITEMS_PER_PAGE = 12;
